import Criteria from './Criteria'

export default class CustomEntityEntryFields extends Criteria{

  getProperties() {
    return [
      {cac_descricao: 'Identificador Alternativo', cac_codigo: 'alternativeIdentifier'},
      {cac_descricao: 'Descrição', cac_codigo: 'description'}
    ]
  }
}
